import { useEffect, useRef } from 'react';

import { createPortal } from 'react-dom';

import { cn } from 'components/lib/utils';

import { ModalProps } from './Modal.types';

export const Modal = ({ isOpen, onClose, children, width, height, className }: ModalProps) => {
    const modalRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleEscape = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('keydown', handleEscape);
            document.body.style.overflow = 'hidden';
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = '';
        };
    }, [isOpen, onClose]);

    const handleOverlayClick = (event: React.MouseEvent<HTMLDivElement>) => {
        if (event.target === event.currentTarget) {
            onClose();
        }
    };

    if (!isOpen) return null;

    // Build dynamic styles for width and height
    const getSize = (size: string | number | undefined) => {
        if (size === undefined) return undefined;
        return typeof size === 'number' ? `${size}px` : size;
    };

    const modalStyle: React.CSSProperties = {
    };

    const widthValue = getSize(width);
    const heightValue = getSize(height);

    if (widthValue) modalStyle.width = widthValue;
    if (heightValue) modalStyle.height = heightValue;

    return createPortal(
        <div
            onClick={handleOverlayClick}
            className={cn("fixed inset-0 bg-base-card/50 backdrop-blur-sm flex justify-center items-center z-[9999]", className)}
        >
            <div
                ref={modalRef}
                className="relative rounded-lg border bg-white shadow-lg p-6 flex flex-col items-end gap-7"
                style={modalStyle}
            >
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors text-gray-500 hover:text-gray-700"
                    aria-label="Close modal"
                >
                    <img src={'./assets/icons/xIcon.svg'} alt="Close" className="w-3 h-3" />
                </button>
                {children}
            </div>
        </div>,
        document.body
    );
};

